var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card"},[_c('a',{staticClass:"app-link",attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"app-short-desc"},[_vm._v(_vm._s(_vm.details))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86be2f66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/AppCard.vue
// module id = null
// module chunks = 